/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { GbcarApiConfiguration as __Configuration } from '../gbcar-api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { SystemRoleModuleAccessRightDto } from '../models/system-role-module-access-right-dto';
import { ChangeSystemRoleModuleAccessRightRequestDto } from '../models/change-system-role-module-access-right-request-dto';
@Injectable({
  providedIn: 'root',
})
class SystemRoleModuleAccessRightService extends __BaseService {
  static readonly getApiSystemRoleModuleAccessRightRoleIdPath = '/api/SystemRoleModuleAccessRight/{roleId}';
  static readonly putApiSystemRoleModuleAccessRightPath = '/api/SystemRoleModuleAccessRight';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param roleId undefined
   * @return Success
   */
  getApiSystemRoleModuleAccessRightRoleIdResponse(roleId: number): __Observable<__StrictHttpResponse<Array<SystemRoleModuleAccessRightDto>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/SystemRoleModuleAccessRight/${encodeURIComponent(String(roleId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<SystemRoleModuleAccessRightDto>>;
      })
    );
  }
  /**
   * @param roleId undefined
   * @return Success
   */
  getApiSystemRoleModuleAccessRightRoleId(roleId: number): __Observable<Array<SystemRoleModuleAccessRightDto>> {
    return this.getApiSystemRoleModuleAccessRightRoleIdResponse(roleId).pipe(
      __map(_r => _r.body as Array<SystemRoleModuleAccessRightDto>)
    );
  }

  /**
   * @param body undefined
   * @return Success
   */
  putApiSystemRoleModuleAccessRightResponse(body?: ChangeSystemRoleModuleAccessRightRequestDto): __Observable<__StrictHttpResponse<Array<SystemRoleModuleAccessRightDto>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/SystemRoleModuleAccessRight`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<SystemRoleModuleAccessRightDto>>;
      })
    );
  }
  /**
   * @param body undefined
   * @return Success
   */
  putApiSystemRoleModuleAccessRight(body?: ChangeSystemRoleModuleAccessRightRequestDto): __Observable<Array<SystemRoleModuleAccessRightDto>> {
    return this.putApiSystemRoleModuleAccessRightResponse(body).pipe(
      __map(_r => _r.body as Array<SystemRoleModuleAccessRightDto>)
    );
  }
}

module SystemRoleModuleAccessRightService {
}

export { SystemRoleModuleAccessRightService }
